import React from 'react';
import PropTypes from 'prop-types';

import { DataHooks } from './constants';
import { classes } from './ColorPickerHistory.st.css';

const ColorPickerHistory = ({ show, current, previous, onClick }) => {
  const handleKeyDown = e => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick(previous);
    }
  };

  if (show) {
    return (
      <div className={classes.root} data-hook={DataHooks.history}>
        <div
          data-hook={DataHooks.historyPrevious}
          style={{ background: previous.hex() }}
          onClick={() => onClick(previous)}
          onKeyDown={handleKeyDown}
          tabIndex={0}
          role="button"
          aria-label={`Previous color: ${previous.hex()}`}
        />
        <div
          data-hook={DataHooks.historyCurrent}
          style={{ background: current.hex() }}
          role="img"
          aria-label={`Current color: ${current.hex()}`}
        />
      </div>
    );
  }
  return null;
};

ColorPickerHistory.propTypes = {
  show: PropTypes.bool.isRequired,
  previous: PropTypes.object.isRequired,
  current: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default ColorPickerHistory;
